import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-top-left-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M8.5 4a.5.5 0 0 1 .354.854L7.207 6.5l5.647 5.646a.5.5 0 0 1-.708.708L6.5 7.207 4.854 8.854a.5.5 0 0 1-.847-.268L4 8.5v-4a.5.5 0 0 1 .5-.5Z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
